"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareBar = exports.ShareBarSize = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const clsx_1 = __importDefault(require("clsx"));
const shareDestinations_1 = require("../shareDestinations");
const LinkSharing_1 = require("./LinkSharing");
const OffPlatformSharing_1 = require("./OffPlatformSharing");
const ShareBar_module_css_1 = __importDefault(require("./ShareBar.module.css"));
const EmbedSharing_1 = require("./EmbedSharing");
var ShareBarSize;
(function (ShareBarSize) {
    ShareBarSize[ShareBarSize["SMALL"] = 0] = "SMALL";
    ShareBarSize[ShareBarSize["MEDIUM"] = 1] = "MEDIUM";
    ShareBarSize[ShareBarSize["LARGE"] = 2] = "LARGE";
})(ShareBarSize = exports.ShareBarSize || (exports.ShareBarSize = {}));
/**
 *
 */
function ShareBar({ url, title, pageType, pageName, incrementCounter, shareDestinations, size = ShareBarSize.LARGE, shouldUseShadow = false, isEmbedSharingEnabled = false, wrap = true, }) {
    const intl = (0, react_intl_1.useIntl)();
    const destinations = shareDestinations || (0, shareDestinations_1.allDesktopSharingDestinations)(true);
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, clsx_1.default)(shouldUseShadow ? ShareBar_module_css_1.default.shareContainerBoxShadow : ShareBar_module_css_1.default.shareContainer, wrap && ShareBar_module_css_1.default.wrap), "data-testid": "shareBar", children: [(0, jsx_runtime_1.jsx)(OffPlatformSharing_1.OffPlatformSharing, { url: url, pageName: pageName, pageType: pageType, shareDestinations: destinations, incrementCounter: incrementCounter, children: isEmbedSharingEnabled && ((0, jsx_runtime_1.jsx)(EmbedSharing_1.EmbedSharing, { pageName: pageName, pageType: pageType, shareDestinations: destinations, incrementCounter: incrementCounter, shareLink: url, title: title })) }), (0, jsx_runtime_1.jsx)(LinkSharing_1.LinkSharing, { shareLink: url, pageType: pageType, pageName: pageName, tooltipMessage: intl.formatMessage({
                    id: "8y4OLC",
                    defaultMessage: "URL Copied!",
                    description: "URL Copied tooltip text",
                }), size: size, incrementCounter: incrementCounter })] }));
}
exports.ShareBar = ShareBar;
//# sourceMappingURL=ShareBar.js.map